import MasonryWall from '@yeger/vue2-masonry-wall/dist/index.umd.js'
import Vue from 'vue'

Vue.use(MasonryWall)
